var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Gutenberg',{attrs:{"data":_vm.post.gds_blocks}}),(_vm.menuBlocks && _vm.menuBlocks.length > 0)?_c('PageMenu',{attrs:{"data":_vm.menuBlocks}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }